import { NavLink } from 'react-router-dom';
import type { Order } from '@/lib/data';

const statusConfig: Record<string, { color: string; bg: string; label: string }> = {
  received: { color: 'text-secondary-600', bg: 'bg-secondary-100', label: 'Received' },
  preparing: { color: 'text-accent-600', bg: 'bg-accent-100', label: 'Preparing' },
  ready: { color: 'text-primary-600', bg: 'bg-primary-100', label: 'Ready' },
  served: { color: 'text-foreground-500', bg: 'bg-background-200', label: 'Served' },
};

const typeIcons: Record<string, string> = {
  'Dine-in': 'ri-restaurant-line',
  'Takeaway': 'ri-takeaway-line',
  'Swiggy': 'ri-motorbike-line',
  'Zomato': 'ri-motorbike-line',
};

interface LiveOrdersProps {
  orders: Order[];
}

export default function LiveOrders({ orders }: LiveOrdersProps) {
  return (
    <div className="bg-background-50 border border-background-200 rounded-lg p-4 md:p-5">
      <div className="flex items-center justify-between mb-3">
        <h4 className="text-sm font-semibold text-foreground-800">Live Orders</h4>
        <NavLink to="/dashboard/orders" className="text-xs text-primary-500 cursor-pointer hover:text-primary-600 font-medium">
          View all
        </NavLink>
      </div>
      {orders.length === 0 ? (
        <div className="py-10 flex flex-col items-center gap-2 text-center">
          <i className="ri-shopping-bag-line text-2xl text-foreground-300"></i>
          <p className="text-sm text-foreground-400">No active orders right now</p>
        </div>
      ) : (
        <div className="space-y-1">
          {orders.slice(0, 5).map((order) => {
            const status = statusConfig[order.status] || statusConfig.received;
            return (
              <div
                key={order.id}
                className="flex items-center gap-3 py-2.5 px-2 rounded-md hover:bg-background-100 transition-colors cursor-pointer"
              >
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className={`${typeIcons[order.type] || 'ri-shopping-bag-line'} text-foreground-400 text-sm`}></i>
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2">
                    <span className="text-sm font-medium text-foreground-700">#{order.id.slice(0, 8)}</span>
                    <span className="text-xs text-foreground-400">{order.type}</span>
                  </div>
                  <span className="text-xs text-foreground-400">
                    {order.tableId ? `${order.tableId} · ` : ''}{order.itemCount} items
                  </span>
                </div>
                <div className="flex items-center gap-3">
                  <span className={`text-xs px-2 py-0.5 rounded-full font-medium ${status.color} ${status.bg}`}>
                    {status.label}
                  </span>
                  <span className="text-sm font-medium text-foreground-800 whitespace-nowrap">₹{order.total.toLocaleString('en-IN')}</span>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
